/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Preview_UnavailableInputs */

const vi_einvoice_error_preview_unavailable = /** @type {(inputs: Einvoice_Error_Preview_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không kết nối được MISA để tạo bản xem trước hóa đơn. Vui lòng thử lại sau vài phút.`)
};

/**

* @param {Einvoice_Error_Preview_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_preview_unavailable = /** @type {((inputs?: Einvoice_Error_Preview_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Preview_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_preview_unavailable(inputs)
});